/**
 * 月度收支统计组件
 * zxw
 * 创建时间：2025-12-10
 */

import { useEffect } from 'react';
import { Chart } from '@antv/g2';
import { Skeleton } from 'antd';
import CNF from '../../incs/Config.js';
import { isMobileDevice } from '../../incs/FunHelper.js';


const ChartIntervalMonthIOAmount = (props) => {
    const { children, id, title, subtitle, streamStatus } = props;

    const timestamp = new Date().getTime().toString();
    const chartId = `${id ? id : 'antv-g2-id'}.${timestamp}`;

    // 加载中显示默认图片
    if (streamStatus === 'loading') {
        return <Skeleton.Image active={true} />;
    }


    useEffect(() => {
        const chart = new Chart({
            container: chartId,
            autoFit: isMobileDevice,
        });

        chart.title({
            title: title,
            subtitle: subtitle,
        });

        // 格式化数据
        chart.data(JSON.parse(children));

        chart
            .interval()
            .data(data)
            .encode('x', '月份')
            .encode('y', '金额')
            .encode('color', 'type')
            .transform({ type: 'dodgeX' })
            // .animate('enter', {
            //     type: 'scaleInY',
            //     duration: CNF.animateDuration,
            // },)
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('y', {
                labelFormatter: (d) => `${d > 10000 ? (d / 10000).toFixed(2) + '万元' : d + '元'}`
            })
            .style('minWidth', 20)
            .style('maxWidth', 40)
            .tooltip({
                items: [(d => ({
                    name: '金额',
                    value: `${d.金额 > 10000 ? (d.金额 / 10000).toFixed(2) + '万元' : d.金额 + '元'}`,
                }))],
            });


        chart.render();

        return () => {
            chart.destroy();
        }
    }, []);

    return <div id={chartId}></div>

}

export default ChartIntervalMonthIOAmount;